import styled from "styled-components";
import colors from "../../../assets/styles/colors";

export const TakerContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: ${colors.bgGray};
`;

export const TakerWrapper = styled.div``;

export const TakerContent = styled.div`
  width: 100%;
  max-width: 610px;
  padding-top: 20px;
  padding-bottom: 20px;
`;

export const TakerLineFormLabel = styled.div`
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
  color: ${colors.textPrimary};
`;

